import { GenderField } from "../../../../utils/form";

const GenderInput = ({ form: { control } }) => (
  <GenderField control={control} name="gender" label="Género" required />
);

export default GenderInput;